export const CHAT_AUTH_HEADER = 'chat-authorization';

export const STREAMING_STATUSES = new Set([
  'queued',
  'pending',
  'running',
  'in_progress',
  'streaming',
]);

export const DEFAULT_VISUALIZATION_TYPE = 'table';

export const COMPONENT_DRAFT_CONFIG = {
  'basket-affinity-topic': {
    title:
      'Within the store Sector that Category exists in, which Categories are in the basket with Product Category and how does Product impact basket size?',
    type: 'table',
  },
  'brand-defense-brand-exclusivity': {
    title:
      'How well does Product drive exclusivity in Category at Place, based on product shoppers?',
    type: 'table',
  },
  'brand-defense-category-brand-performance': {
    title:
      'How is Product doing in context with other Category products in terms of household penetration and buy rate?',
    type: 'table',
  },
  'brand-defense-category-conversion': {
    title: 'How well does Product convert shoppers into the Category category?',
    type: 'bar-stack-chart',
  },
  'brand-defense-competitive-basket': {
    title: 'Does Product drive competitive basket spend versus other Category products?',
    type: 'scatter-chart',
  },
  'brand-defense-non-closer-stores': {
    title: 'Where do non-converted shoppers at Place go to purchase Product instead?',
    type: 'table',
  },
  'brand-defense-shopper-conversion': {
    title: 'How well do top retailers convert Product Category shoppers at their stores?',
    type: 'bar-chart',
  },
  'brand-defense-shopper-profile': {
    title:
      'How do Product shoppers compare to other Category shoppers (buy Category but not Product) demographically?',
    type: 'table',
  },
  'brand-defense-shopper-value': {
    title:
      'How valuable are Product shoppers to the total Category category vs shoppers of other products, based on buy rate and purchase frequency?',
    type: 'table',
  },
  'brand-sell-in-category-conversion': {
    title: 'How well does Product convert shoppers into the Category category across stores?',
    type: 'bar-stack-chart',
  },
  'brand-sell-in-category-leakage': {
    title: 'How well does Store convert total Category category shoppers at their stores?',
    type: 'bar-chart-two-labels',
  },
  'brand-sell-in-category-leakage-to-brand-elsewhere': {
    title:
      'To what extent and where do non-converted Category category shoppers at Store go to purchase Product?',
    type: 'bar-chart',
  },
  'brand-sell-in-consecutive-repeat-rate': {
    title:
      'When Product shoppers make their next trip to the Category category, are they returning to Product?',
    type: 'bar-chart-two-labels',
  },
  'brand-sell-in-metric-tree': {
    title:
      'How did panel metrics impact the YOY change in Product spend (anywhere, not specific to Store)?',
    type: 'brand-tree-v2',
  },
  'brand-sell-in-shopper-profile': {
    title:
      'How do Product shoppers (anywhere) demographically compare to current Category category shoppers at Store?',
    type: 'table',
  },
  'brand-sell-in-shopper-value': {
    title:
      "How valuable are Product shoppers (who buy it at any store) to the total Category category and total store specifically at Store (even though they don't buy Product there) vs shoppers of competitor products?",
    type: 'table',
  },
  'brand-sell-in-source-of-volume': {
    title: "How incremental has Focus_brand's growth been to the Focus_category category?",
    type: 'ebsova-tree',
  },
  'category-review-category-brand-performance': {
    title: 'How are top brands in Category doing in terms of household penetration and buy rate?',
    type: 'table',
  },
  'category-review-channel-drivers': {
    title: 'Where do shoppers buy Product, by Place vs others?',
    type: 'column-chart',
  },
  'category-review-dev-index-age-generation': {
    title: 'Which generations contribute more than expected to Category category spend Place?',
    type: 'table',
  },
  'category-review-dev-index-regional': {
    title: 'Which regions contribute more than expected to Category category spend at Place?',
    type: 'table',
  },
  'category-review-lrn': {
    title: 'What is the extent of Lapsed, Retained, and New shoppers in the Category at Place?',
    type: 'column-chart',
  },
  'category-review-metric-tree': {
    title: 'How did panel metrics impact the YOY change in Product spend Place?',
    type: 'brand-tree-v2',
  },
  'category-review-place-drivers': {
    title: 'Where do shoppers buy Product, by Place vs others?',
    type: 'column-chart',
  },
  'category-review-retailer-drivers': {
    title: 'Where do shoppers buy Product, by Place vs others?',
    type: 'column-chart',
  },
  'category-review-seasonality': {
    title: 'How is Category spend distributed by month at Place?',
    type: 'column-chart',
  },
  'category-review-shopper-profile': {
    title: 'How do Place Category shoppers compare demographically to all Place shoppers?',
    type: 'table',
  },
  'closure-rate-sow-product-comparison-topic': {
    title:
      'How well does Place convert Product Category shoppers at their stores, versus other Category products at Store?',
    type: 'bar-chart',
  },
  'diagnosing-growth-category-conversion-among-new': {
    title: 'To what extent were new Product shoppers also new to the Category category?',
    type: 'bar-stack-chart',
  },
  'diagnosing-growth-category-retention-after-lapsing': {
    title: 'To what extent did lapsed Product shoppers continue buying other Category products?',
    type: 'bar-stack-chart',
  },
  'diagnosing-growth-lrn': {
    title: 'What is the extent of lapsed, retained, and new shoppers for Product Category?',
    type: 'column-chart',
  },
  'diagnosing-growth-metric-tree': {
    title: 'How did panel metrics impact the YOY change in Product spend at Place?',
    type: 'brand-tree-v2',
  },
  'diagnosing-growth-source-of-volume': {
    title: 'What was the source of volume for Product in the Category category?',
    type: 'ebsova-tree',
  },
  'diagnosing-growth-yoy-changes-product-vs-category': {
    title:
      'How did the year-over-year KPI changes for Product in Category compare to those for the rest of the Category?',
    type: 'table',
  },
  'diagnosing-growth-yoy-metrics-by-demographics': {
    title:
      'How did the year-over-year KPI changes for Product in Category compare across demographics?',
    type: 'table',
  },
  'diagnosing-growth-yoy-metrics-retained-shoppers': {
    title:
      'How did key purchasing metrics change year over year among retained shoppers of Product Category?',
    type: 'table',
  },
  'incrementality-basket-value': {
    title: 'Do baskets with Product drive more value than other Category baskets?',
    type: 'table',
  },
  'incrementality-brand-exclusivity': {
    title:
      'How well does Product drive exclusivity in Category at Place, based on product shoppers?',
    type: 'bar-chart-two-labels',
  },
  'incrementality-brand-exclusivity-among-category': {
    title: 'How well does Product drive exclusivity in Category, based on category shoppers?',
    type: 'bar-chart-two-labels',
  },
  'incrementality-category-conversion': {
    title: 'How well does Product convert shoppers into the Category category?',
    type: 'bar-stack-chart',
  },
  'incrementality-overlapping-spend': {
    title:
      'Do shoppers buying both Product and other Category products drive higher spend than those buying only one or the other?',
    type: 'table',
  },
  'incrementality-poe': {
    title:
      'Are shoppers entering the Category category through Product more or less than expected?',
    type: 'table',
  },
  'incrementality-share-of-category-requirements': {
    title: 'How loyal are Product shoppers within Category?',
    type: 'table',
  },
  'incrementality-source-of-volume': {
    title: 'How incremental has Product growth been to the Category category?',
    type: 'incrementality-source-of-volume',
  },
  'lapsed-retained-new-comparison-topic': {
    title:
      'Within Category, how does Product compare to other products in terms of Lapsed, Retained, and New Households?',
    type: 'bar-stack-chart',
  },
  'market-landscape-competitive-dynamics': {
    title: 'How is Category spend shifting across Place and its competitors?',
    type: 'column-chart',
  },
  'market-landscape-growth-breakdown': {
    title: 'Which KPIs explain Category spend growth or decline at Place?',
    type: 'brand-tree-v2',
  },
  'market-landscape-retailer-mix': {
    title: 'Where do shoppers buy Category, and how is that mix shifting over time?',
    type: 'column-chart',
  },
  'market-landscape-shopper-profile': {
    title: 'How do Category shoppers at Place compare demographically to the total market?',
    type: 'table',
  },
  'market-landscape-shopper-value': {
    title: 'How much do Category shoppers spend at Place vs other retailers?',
    type: 'table',
  },
  'product-spend-by-category-engagement-topic': {
    title: 'How do shoppers at different Category category engagement levels spend on Product?',
    type: 'table',
  },
  'retailer-conversion-competitive-drivers': {
    title: 'What draws shoppers to buy Category at Place versus competitors?',
    type: 'column-chart',
  },
  'retailer-conversion-metric-tree': {
    title: 'How did panel metrics impact the YOY change in Category spend at Place?',
    type: 'brand-tree-v2',
  },
  'retailer-conversion-shopper-profile': {
    title: 'How do Category shoppers at Place differ demographically from the total market?',
    type: 'table',
  },
  'retailer-conversion-shopper-value': {
    title:
      'How valuable are Category shoppers at Place vs shoppers at other retailers (spend + trips)?',
    type: 'table',
  },
  'retailer-conversion-source-of-volume': {
    title: 'Where are Place Category shoppers coming from vs the total market?',
    type: 'ebsova-tree',
  },
  'retailer-defense-competitive-dynamics': {
    title: 'Which KPIs explain Category spend gains/losses at Place vs competitors?',
    type: 'brand-tree-v2',
  },
  'retailer-defense-cross-shopping': {
    title: 'Where do Category shoppers go when they don’t buy at Place?',
    type: 'column-chart',
  },
  'retailer-defense-retailer-drivers': {
    title: 'What drives Category shoppers to buy at Place vs elsewhere?',
    type: 'column-chart',
  },
  'retailer-defense-shopper-profile': {
    title: 'How do Place Category shoppers compare demographically to other retailers?',
    type: 'table',
  },
  'retailer-defense-shopper-value': {
    title: 'How much are Place Category shoppers worth vs shoppers at other retailers?',
    type: 'table',
  },
  'retailer-defense-source-of-volume': {
    title: 'Where is Category growth coming from for Place?',
    type: 'ebsova-tree',
  },
  'top-products-among-lapsed-buyers-topic': {
    title: 'After lapsing from Product, what other Category products did shoppers buy?',
    type: 'table',
  },
  'top-products-among-leaked-shoppers-topic': {
    title:
      'Among shoppers who shop at Place but buy their Category elsewhere, what are the top Category products they purchase anywhere?',
    type: 'table',
  },
  'top-products-among-new-buyers-topic': {
    title: 'Among shoppers new to Product, what other Category products did they buy?',
    type: 'table',
  },
  'trip-diagnostics-basketing': {
    title:
      'Which complementary items do Category basket shoppers add during trips to Place vs elsewhere?',
    type: 'table',
  },
  'trip-diagnostics-brand-performance': {
    title: 'How are top brands in Category performing on key KPIs at Place?',
    type: 'table',
  },
  'trip-diagnostics-channel-drivers': {
    title: 'Where do shoppers buy Category, and what motivates their trips by channel?',
    type: 'column-chart',
  },
  'trip-diagnostics-metric-tree': {
    title: 'How did panel metrics impact the YOY change in Category trips at Place?',
    type: 'brand-tree-v2',
  },
  'trip-diagnostics-trip-friction': {
    title: 'Why are shoppers abandoning Category trips at Place?',
    type: 'table',
  },
  'trip-diagnostics-trip-value': {
    title: 'How much are Category trips worth at Place vs other retailers?',
    type: 'table',
  },
  'who-is-my-shopper-banner-drivers': {
    title: 'Where do shoppers buy Product, by Attribute?',
    type: 'column-chart',
  },
  'who-is-my-shopper-category-conversion': {
    title: 'How well does Product convert shoppers into the Category category?',
    type: 'bar-stack-chart',
  },
  'who-is-my-shopper-channel-drivers': {
    title: 'Where do shoppers buy Product, by Attribute?',
    type: 'column-chart',
  },
  'who-is-my-shopper-cross-shopping': {
    title: 'At Place, are Product shoppers interacting with other products in Category?',
    type: 'table',
  },
  'who-is-my-shopper-demo-differences': {
    title: 'How do key demographics differ in their spending on Product Category at Place?',
    type: 'table',
  },
  'who-is-my-shopper-demo-shifts': {
    title:
      'Which demographics have growing/declining household penetration for Product compared to the total Category category at Place?',
    type: 'table',
  },
  'who-is-my-shopper-metrics-tree': {
    title: 'How did panel metrics impact the YOY change in Product spend at Place?',
    type: 'brand-tree-v2',
  },
  'who-is-my-shopper-place-drivers': {
    title: 'Where do shoppers buy Product, by Attribute?',
    type: 'column-chart',
  },
  'who-is-my-shopper-shopper-profile': {
    title:
      'How do Place Product Category shoppers demographically compare to total Place Category shoppers?',
    type: 'table',
  },
};

export const IGNORED_TOOL_NAMES = new Set([
  'retrieve_component_descriptions',
  'retrieve_topic_card_descriptions',
  'update_components',
  'update_topic_cards',
  'prompt_search',
]);
